import type { ResourceContainer as ResourceContainerModel } from '@/adapters/catalogv1.g';

export function extractResourceContainer(model: ResourceContainerModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.container_ref ?? '',
    name: model.name ?? '',
    containerType: model.container_type ?? '',
    description: model.description ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogResourceContainer = ReturnType<
  typeof extractResourceContainer
>;
